import _Object$keys from 'babel-runtime/core-js/object/keys';

import _data from '@/utils/emoji-data.js';
export default {
  name: 'Emoji',
  data: function data() {
    return {
      emojiData: _data,
      pannels: ['表情', '自然', '物品', '地点', '符号'],
      activeIndex: 0
    };
  },

  computed: {
    emojis: function emojis() {
      var _this = this;

      return this.pannels.map(function (item) {
        return _Object$keys(_this.emojiData[item]);
      });
    }
  },
  created: function created() {},

  methods: {
    changeActive: function changeActive(index) {
      this.activeIndex = index;
    },
    getPureName: function getPureName(name) {
      return name.replace(/:/g, '');
    },
    selectItem: function selectItem(emoji) {
      this.$emit('select', emoji);
    }
  }
};